const initialState = {
    auth: false,
    authToken: ''
};
export default initialState;
